// groupCabinetsByFurniture.js — grynoji f-ja, sugrupuojanti plokščią `cabinets`
// masyvą į atskirus baldo vienetus (furnitureId), su kiekvieno bendru gabaritu.
// Naudojama Suvestinėje, kad kiekvienam baldo vienetui būtų galima atskirai
// suskaičiuoti kainą ir sugeneruoti brėžinį.

export const groupCabinetsByFurniture = (cabinets = []) => {
    const groups = {};
    const order = [];

    (cabinets || []).forEach((cab) => {
        const fid = cab.furnitureId;
        if (fid == null) return;
        if (!groups[fid]) {
            groups[fid] = {
                furnitureId: fid,
                cabinets: [],
                minX: Infinity, maxX: -Infinity,
                minY: Infinity, maxY: -Infinity,
                depth: 0,
            };
            order.push(fid);
        }
        const g = groups[fid];
        g.cabinets.push(cab);
        const x = Number(cab.x) || 0;
        const y = Number(cab.y) || 0;
        const w = Number(cab.width) || 0;
        const h = Number(cab.height) || 0;
        const d = Number(cab.depth) || 0;
        g.minX = Math.min(g.minX, x);
        g.maxX = Math.max(g.maxX, x + w);
        g.minY = Math.min(g.minY, y);
        g.maxY = Math.max(g.maxY, y + h);
        g.depth = Math.max(g.depth, d);
    });

    return order.map((fid, index) => {
        const g = groups[fid];
        // NEBŪTINA rikiuoti pagal x — paliekama ta pati tvarka, kaip
        // `furnitureData.cabinets.filter(c => c.furnitureId === fid)` (žr. Layout.jsx
        // activeCabinets), nes mergedSections/sectionOptions/doorHandles raktai
        // referencuoja cabinetIndex būtent tos filtruotos (nerikiuotos) tvarkos atžvilgiu.
        return {
            furnitureId: fid,
            index,
            label: `Baldas ${index + 1}`,
            cabinets: g.cabinets,
            x: g.minX,
            y: g.minY,
            width: g.maxX - g.minX,
            height: g.maxY - g.minY,
            depth: g.depth,
        };
    });
};
